<template>
    <CampsPanel/>
</template>

<script>
import CampsPanel from './CampsPanel'
export default {
    name: 'Campaigns',
    components: {
        CampsPanel
    }
}
</script>

<style>

</style>